import React from 'react';

import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import PartialsQuestion from '../../components/Partials/PartialsQuestion';
import MainView from '../../components/service/Audit/MainView';

const CodeAudit = () => {
  return (
    <Layout
      title="Code review and audit - verify quality of your code | Ulam Labs"
      description="Good product starts with high quality code. We help investors that runs due diligence, a third-party software supplier or support the process of recruiting an outsourcing company."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Code audit</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <MainView />
      <PartialsQuestion
        title="Have a question?"
        subtitle="Feel free to contact us."
      />
    </Layout>
  );
};

export default CodeAudit;
